import { Environments } from '@innovyze/lib_get_service';

const config: any = {
  [Environments.LOCAL]: {
    amso: 'http://localhost:8000',
  },
};

export const apiEnv =
  (localStorage.getItem('apiEnv') as keyof typeof Environments) || undefined;

export default config;
